
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"homepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"homepage","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"homepage_homepage_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hero"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeroArea"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"promoBanner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromoBanner"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pageContent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Row"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticlesBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InformationGuidesBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FaqsBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TestimonialBlock"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Highlight"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Videos"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesFormCta"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmenitiesBlock"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":600}};
    doc.loc.source = {"body":"#import \"@/graphql/HeroArea.graphql\"\n#import \"@/graphql/PageContent.graphql\"\n#import \"@/graphql/PromoBanner.graphql\"\n\nquery homepage($site: [String]) {\n  entry(section: \"homepage\", site: $site) {\n    ... on homepage_homepage_Entry {\n      id\n      slug\n\n      hero {\n        ...HeroArea\n      }\n\n      promoBanner {\n        ...PromoBanner\n      }\n\n      pageContent {\n        ...Row\n        ...ArticlesBlock\n        ...InformationGuidesBlock\n        ...FaqsBlock\n        ...TestimonialBlock\n        ...Highlight\n        ...Videos\n        ...SalesFormCta\n        ...AmenitiesBlock\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/HeroArea.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/PageContent.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/PromoBanner.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["homepage"] = oneQuery(doc, "homepage");
        
